import React from 'react';
import { Helmet } from 'react-helmet';

function About() {
  const teamMembers = [
    {
      id: 1,
      name: 'Anna Schmidt',
      position: 'Geschäftsführerin',
      bio: 'Mit über 20 Jahren Erfahrung in der Baubranche leitet Anna unser Unternehmen mit Leidenschaft und Innovation. Sie setzt neue Maßstäbe in der Qualitätssicherung.'
    },
    {
      id: 2,
      name: 'Maria Weber',
      position: 'Technische Leiterin',
      bio: 'Maria ist unsere Expertin für technische Lösungen und Materialentwicklung. Ihre Innovationen haben zahlreiche Auszeichnungen erhalten.'
    },
    {
      id: 3,
      name: 'Thomas Müller',
      position: 'Produktionsleiter',
      bio: 'Thomas sorgt für reibungslose Abläufe in der Produktion und garantiert höchste Qualitätsstandards bei jedem einzelnen Produkt.'
    },
    {
      id: 4,
      name: 'Lisa Hoffmann',
      position: 'Kundenberaterin',
      bio: 'Lisa ist Ihre erste Ansprechpartnerin für alle Fragen rund um unsere Produkte und Services. Sie berät Sie kompetent und freundlich.'
    },
    {
      id: 5,
      name: 'Michael Fischer',
      position: 'Entwicklungsleiter',
      bio: 'Michael entwickelt innovative Lösungen für die Zukunft der Finishing-Branche und arbeitet an nachhaltigen Materialien der nächsten Generation.'
    }
  ];

  return (
    <div className="about-section">
      <Helmet>
        <title>Über uns - Lackfertighaus Team und Geschichte</title>
        <meta name="description" content="Lernen Sie das Team von Lackfertighaus kennen. Erfahrung, Leidenschaft und Expertise für erstklassige Ausbauarbeiten." />
        <meta property="og:title" content="Über Lackfertighaus - Unser Team" />
        <link rel="canonical" href="https://lackfertighaus.com/about" />
      </Helmet>

      <h1>Über Lackfertighaus</h1>

      <div className="about-text-content" style={{ marginBottom: '4rem' }}>
        <h3>Unsere Geschichte</h3>
        <p>
          Lackfertighaus wurde 2010 mit der Vision gegründet, die Ausbau- und Finishing-Branche zu revolutionieren. 
          Was als kleines Familienunternehmen begann, hat sich zu einem führenden Anbieter für Premium-Lösungen 
          in Deutschland entwickelt. Unser Erfolg basiert auf dem Engagement für Qualität, Innovation und 
          außergewöhnlichen Kundenservice.
        </p>
        
        <h3>Unsere Mission</h3>
        <p>
          Wir verbinden traditionelle Handwerkskunst mit modernster Technologie, um unseren Kunden die besten 
          Finishing-Lösungen zu bieten. Nachhaltigkeit, Qualität und Kundenzufriedenheit stehen im Mittelpunkt 
          unseres Handelns. Jedes Projekt ist für uns eine Gelegenheit, Exzellenz zu demonstrieren.
        </p>

        <h3>Unsere Werte</h3>
        <p>
          Integrität, Präzision und Leidenschaft prägen unsere tägliche Arbeit. Wir glauben daran, dass 
          Details den Unterschied machen und setzen alles daran, die Erwartungen unserer Kunden nicht nur 
          zu erfüllen, sondern zu übertreffen. Unser Team aus erfahrenen Fachleuten arbeitet kontinuierlich 
          an neuen Lösungen und Verbesserungen.
        </p>
      </div>

      <section className="team-section">
        <h2>Unser Expertenteam</h2>
        <div className="team-grid">
          {teamMembers.map(member => (
            <div key={member.id} className="team-card">
              <img 
                src={`/images/team_${member.id}.jpg`} 
                width="400" 
                height="400" 
                alt={`Team member ${member.id}`} 
                className="team-photo"
              />
              <div className="team-info">
                <h3>{member.name}</h3>
                <p className="team-position">{member.position}</p>
                <p className="team-bio">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default About;